import { Badge } from "./Badge";
import Util from '../../Util';
import { useTranslation } from "react-i18next";



const StatusBadge = ({ status, className }) => {
  const { t } = useTranslation();
  const statusConfig = {
    new: {
      id: 1,
      label: t("new"),
      color: "text-blue-700 dark:text-blue-400",
      bg: "bg-blue-100/50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800",
    },

    sent: {
      id: 2,
      label: t("sent"),
      color: "text-amber-700 dark:text-amber-400",
      bg: "bg-amber-100/50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800",
    },

    received: {
      id: 3,
      label: t("received"),
      color: "text-emerald-700 dark:text-emerald-400",
      bg: "bg-emerald-100/50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-800",
    },

    must_return: {
      id: 4,
      label: t("mustReturn"),
      color: "text-red-700 dark:text-red-400",
      bg: "bg-red-100/50 dark:bg-red-900/20 border-red-200 dark:border-red-800",
    },

    returned: {
      id: 5,
      label: t("returnedToSupplier"),
      color: "text-purple-700 dark:text-purple-400",
      bg: "bg-purple-100/50 dark:bg-purple-900/20 border-purple-200 dark:border-purple-800",
    },

    approved: {
      id: 6,
      label: t("approved"),
      color: "text-slate-700 dark:text-slate-400",
      bg: "bg-slate-100/50 dark:bg-slate-900/20 border-slate-200 dark:border-slate-800",
    },
  };


  const config = Object.values(statusConfig).find(cfg => cfg.id === status);
  const classes = Util.cn(
    "font-bold whitespace-nowrap inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover-elevate",
    config ? config.color : "",
    config ? config.bg : ""
  )
  return (
    <Badge
      variant="outline"
      className={classes}
    >
      {config ? config.label : ''}
    </Badge>
  );
}
export default StatusBadge;